var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('user-table',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeKey===1),expression:"activeKey===1"}],ref:"list",on:{"add":_vm.add,"edit":_vm.edit,"enable":_vm.enable}}),_c('user-detail',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeKey===2),expression:"activeKey===2"}],ref:"detail",on:{"back":_vm.back}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }